import { jsx as _jsx } from "react/jsx-runtime";
import AddLinkedAccountRow from '../../components/AddLinkedAccountRow';
const AddSocialMediaAccountItem = ({ handleConnectAccounts }) => (_jsx(AddLinkedAccountRow, { onPress: handleConnectAccounts }));
export default AddSocialMediaAccountItem;
